import styles from './Brands.module.scss';
import { brandsData } from '../../../../../data/mock/brandsData';
import HTMLReactParser from 'html-react-parser';

const Brands = () => {
  return (
    <div className={styles.Brands}>
      <h2>Официальные сайты производителей</h2>
      <p>
        Более подробные сведения о продукции доступны на официальных сайтах
        производителей
      </p>
      <div className={styles.holder}>
        {brandsData.map((item, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.image}>
              <img src={item.image} alt={item.title} />
            </div>
            <p>
              <a href={item.link} target="_blank" rel="noreferrer">
                {item.title}
              </a>{' '}
              — {HTMLReactParser(item.description)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Brands;
